import api from "../../utils/api";

// NZSC-3250: 리포트 신청퍼널 "궁금한점(질문하기)" 노출 스위치.
// 관리자(궁금한점 검수 메뉴)에서 토글 → api-public /report/qna-funnel-status(서버 30초 캐시)로 조회.
//   OPEN   = 전체 오픈
//   TESTER = 내부 테스터만 (userStore.isInternalTester)
//   CLOSED = 전체 닫힘 (기존 걱정점 faq 퍼널로 동작)
// NZSC-3308: 같은 응답의 postPayStatus = 결제 후 Q&A 전용 스위치(REPORT_QNA_POST_PAY).
//   funnelStatus(결제 전 자유질문·근저당 특약)와 분리 — 값 규칙은 동일.
// 조회 실패/미조회 시 TESTER 로 fail-safe — 일반 유저는 기존 퍼널이라 사고로 번지지 않는다.
const CLIENT_CACHE_MS = 60 * 1000;

const VALID_STATUSES = ["OPEN", "TESTER", "CLOSED"];

function normalizeStatus(value) {
  return VALID_STATUSES.includes(value) ? value : "TESTER";
}

export const state = {
  funnelStatus: null, // 'OPEN' | 'TESTER' | 'CLOSED' | null(미조회)
  postPayStatus: null, // 'OPEN' | 'TESTER' | 'CLOSED' | null(미조회)
  fetchedAt: 0,
};

export const mutations = {
  SET_QNA_FUNNEL_STATUS(state, { status, postPayStatus }) {
    state.funnelStatus = status;
    state.postPayStatus = postPayStatus;
    state.fetchedAt = Date.now();
  },
};

export const actions = {
  // 퍼널 페이지 mounted 에서 프리페치. 분기 시점(다음 버튼)엔 getter 만 동기 사용.
  async acFetchQnaFunnelStatus({ state, commit }) {
    if (state.funnelStatus && Date.now() - state.fetchedAt < CLIENT_CACHE_MS) {
      return state.funnelStatus;
    }
    try {
      const result = await api.get("/api/v1/report/qna-funnel-status");
      const status = result?.data?.data?.status;
      if (VALID_STATUSES.includes(status)) {
        commit("SET_QNA_FUNNEL_STATUS", {
          status,
          postPayStatus: normalizeStatus(result?.data?.data?.postPayStatus),
        });
        return status;
      }
    } catch (error) {
      // fail-safe: 아래 TESTER 처리
    }
    commit("SET_QNA_FUNNEL_STATUS", { status: "TESTER", postPayStatus: "TESTER" });
    return "TESTER";
  },
};

export const getters = {
  qnaFunnelStatus(state) {
    return state.funnelStatus;
  },
  qnaPostPayStatus(state) {
    return state.postPayStatus;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
